import gsap from 'gsap'
import Component from '../app/component'
import _ from 'lodash-es'

export default class CollectionslistComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    if (this.refs?.bars?.length) {
      this.refs.barsImages.forEach(el => this.tweenBars(el))
    }
  }

  tweenBars (el) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        scrub: true,
        start: 'top bottom',
        end: 'bottom -20%'
      }
    })

    tl.fromTo(
      el,
      {
        x: '15rem'
      },
      {
        x: '-15rem',
        duration: 1,
        ease: 'power1.out'
        // ease: 'none'
      },
      0
    )

    return tl
  }
}
